<template>
  <v-card class="ma-0 px-1" width="100%" flat>
    <v-app-bar flat class="my-0 mb-6 py-1 px-2" dense height="30">
      <v-toolbar-title class="mt-4 me-4">{{ $t(this.$route.name) }}</v-toolbar-title>
      <div v-if="!isMobile && !isTablet" style="width: 230px">
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          clearable
          :label="$t('search')"
          flat
          outlined
          dense
        />
      </div>
      <v-spacer />
      <v-btn
        v-if="selected.length > 0 && !isMobile"
        outlined
        @click="deletDialog = true"
        class="mt-4 ms-2"
        color="pink"
        height="32"
      >
        <p class="font-weight-thin mb-0 me-2">
          {{ $t("remove") }}
        </p>
        <v-icon> mdi-trash-can-outline </v-icon>
      </v-btn>
      <v-menu v-if="isMobile || isTablet" offset-y>
        <template v-slot:activator="{ attrs, on }">
          <v-btn
            outlined
            class="mt-4 px-1 ms-2"
            color="grey darken-2"
            height="32"
            v-bind="attrs"
            v-on="on"
            style="min-width: 35px !important; padding: 0 !important"
          >
            <!-- <p class="mb-0 me-2">
              {{$t('more')}}
            </p> -->
            <v-icon> mdi-dots-vertical </v-icon>
          </v-btn>
        </template>
        <v-list dense>
          <v-list-item v-if="isMobile || isTablet" link @click="getItems">
            <v-list-item-icon>
              <v-icon>mdi-refresh</v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="$t('refresh')" />
          </v-list-item>
          <v-list-item v-if="isMobile || isTablet" link @getAllRows="getAllRows">
            <export-excel
              ref="refExcel"
              :data="excelItems"
              worksheet="abriron.com"
              name="data.xls"
              type="xls"
              class="float-left d-flex"
              :title="$store.state.abrName"
              :total-prop="pageCount"
              :page-prop="excelPage"
              @getAllRows="getAllRows"
            >
              <v-list-item-icon>
                <v-icon>mdi-file-excel-outline</v-icon>
              </v-list-item-icon>
              <v-list-item-title v-text="$t('excel')" />
            </export-excel>
          </v-list-item>
          <v-list-item v-if="isMobile || isTablet" link @click="printDialog = true">
            <v-list-item-icon>
              <v-icon>mdi-printer-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="$t('print')" />
          </v-list-item>
          <v-list-item v-if="isMobile || isTablet" link @click="goTo(type)">
            <v-list-item-icon>
              <v-icon>mdi-plus</v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="$t(type)" />
          </v-list-item>
        </v-list>
      </v-menu>
      <v-btn
        v-if="!isMobile && !isTablet"
        outlined
        @click="getItems"
        class="mt-4 px-1 ms-2"
        color="grey darken-2"
        height="32"
        @shortkey="getItems"
        v-shortkey="['f5']"
        style="min-width: 35px !important; padding: 0 !important"
      >
        <!-- <p class="mb-0 me-2">
          {{$t('refresh')}}
        </p> -->
        <v-icon> mdi-refresh </v-icon>
      </v-btn>
      <export-excel
        v-if="!isMobile && !isTablet"
        ref="refExcel"
        :data="excelItems"
        worksheet="abriron.com"
        name="data-ai.xls"
        type="xls"
        class="float-left"
        :title="$store.state.abrName"
        :total-prop="pageCount"
        :page-prop="excelPage"
        @getAllRows="getAllRows"
      >
        <v-btn outlined class="mt-4 ms-2" color="grey darken-2 " height="32">
          <p class="font-weight-thin mb-0 me-2">
            {{ $t("excel") }}
          </p>
          <v-icon> mdi-file-excel-outline </v-icon>
        </v-btn>
      </export-excel>
      <v-btn
        outlined
        @click="filter = true"
        class="mt-4 ms-2"
        color="grey darken-2 "
        height="32"
      >
        <p class="font-weight-thin mb-0 me-2">
          {{ $t("filter") }}
        </p>
        <v-icon> mdi-filter-outline </v-icon>
      </v-btn>
      <v-btn
        v-if="!isMobile && !isTablet"
        outlined
        @click="printDialog = true"
        class="mt-4 ms-2"
        color="grey darken-2"
        height="32"
      >
        <p class="font-weight-thin mb-0 me-2">
          {{ $t("print") }}
        </p>
        <v-icon> mdi-printer-outline </v-icon>
      </v-btn>
      <v-btn
        v-if="!isMobile && !isTablet"
        outlined
        @shortkey="goTo(type)"
        @click="goTo(type)"
        class="mt-4 ms-2"
        color="primary"
        height="32"
      >
        <p class="font-weight-thin mb-0 me-2">
          {{ $t(type) }}
        </p>
        <v-icon> mdi-plus </v-icon>
      </v-btn>
    </v-app-bar>
    <v-row v-if="isMobile || isTablet" class="mx-0">
      <v-col class="mb-4 px-2" cols="12">
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          clearable
          :label="$t('search')"
          flat
          outlined
          dense
        />
      </v-col>
    </v-row>
    <v-col
      cols="12"
      class="px-2"
      :class="{ 'mt-6': !isMobile && !isTablet, 'mt-0': isMobile || isTablet }"
    >
      <v-data-table
        v-if="headers"
        v-model="selected"
        :height="isMobile || isTablet || mobileShow ? 323 : tableHeight"
        fixed-header
        :headers="showHeaders"
        :items="items"
        :page.sync="page"
        :options.sync="options"
        :server-items-length="totalItems"
        :loading="loading"
        multi-sort
        dense
        :show-select="showSelect"
        item-key="id"
        class="mb-2 td-hide-border"
        style="border: 1px solid #e3e3e3; border-radius: 6px"
        :footer-props="{
          showFirstLastPage: !mobileShow ? true : false,
          itemsPerPageOptions: [10, 25, 50, 100, 500],
          firstIcon: 'mdi-arrow-collapse-left',
          lastIcon: 'mdi-arrow-collapse-right',
          prevIcon: 'mdi-plus',
          nextIcon: 'mdi-minus',
        }"
      >
        <template v-slot:item.actions="{ item }">
          <v-menu offset-y>
            <template v-slot:activator="{ attrs, on }">
              <v-btn color="primary" v-bind="attrs" icon v-on="on">
                <v-icon medium> mdi-dots-vertical </v-icon>
              </v-btn>
            </template>

            <v-list dense>
              <v-list-item link @click="edit(item)">
                <v-list-item-icon>
                  <v-icon>mdi-clipboard-edit</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('edit')" />
              </v-list-item>
              <v-list-item link @click="print(item)">
                <v-list-item-icon>
                  <v-icon>mdi-printer-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('print')" />
              </v-list-item>
              <v-list-item
                v-clipboard:copy="$baseURL + '/' + type + '/edit/' + item.head.uid"
                link
              >
                <v-list-item-icon>
                  <v-icon>mdi-link</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('copy-link')" />
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
        <template v-slot:item.price.price="{ item }">
          {{ $numberFormat(item.price ? item.price.price : 0) }}
          {{ item.currency.symbol }}
        </template>
        <template v-slot:item.product.name="{ item }">
          <div class="d-flex">
            <a
              style="padding-top: 6px"
              class="me-2"
              @click="openComponent('product', item.product_id)"
            >
              {{ item.product.name }}
            </a>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  icon
                  small
                  v-on="on"
                  @click="openComponent('productTurnover', item.product_id)"
                >
                  <v-icon color="teal" style="font-size: 22px">
                    mdi-playlist-check
                  </v-icon>
                </v-btn>
              </template>
              <span>{{ $t("productTurnover") }}</span>
            </v-tooltip>
          </div>
        </template>
        <template v-slot:item.count_product_invoice="{ item }">
          {{ $numberFormat(item.count_product_invoice ? item.count_product_invoice : 0) }}
        </template>
        <template v-slot:item.count_product_return_invoice="{ item }">
          {{
            $numberFormat(
              item.count_product_return_invoice ? item.count_product_return_invoice : 0
            )
          }}
        </template>
        <template v-slot:item.count_invoice="{ item }">
          {{ $numberFormat(item.count_invoice ? item.count_invoice : 0) }}
        </template>
        <template v-slot:item.count_return_invoice="{ item }">
          {{ $numberFormat(item.count_return_invoice ? item.count_return_invoice : 0) }}
        </template>
        <template v-slot:item.amount_invoice="{ item }">
          {{ $numberFormat(item.amount_invoice ? item.amount_invoice : 0) }}
        </template>
        <template v-slot:item.amount_return_invoice="{ item }">
          {{ $numberFormat(item.amount_return_invoice ? item.amount_return_invoice : 0) }}
        </template>
        <template v-slot:item.remainCount="{ item }">
          {{
            $numberFormat(
              +item.count_product_invoice - +item.count_product_return_invoice
            )
          }}
        </template>
        <template v-slot:item.remainAmount="{ item }">
          {{ $numberFormat(+item.amount_invoice - +item.amount_return_invoice) }}
        </template>
        <template v-slot:item.row="{ item }">
          <a @click="edit(item)">
            {{ parseInt(items.indexOf(item)) + parseInt(from) }}
          </a>
        </template>
        <template v-slot:item.time="{ item }">
          {{ item.time }}
        </template>
        <template v-slot:item.user.name="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <div v-if="item.user" color="primary" dark v-bind="attrs" v-on="on">
                {{ item.user.firstname }} {{ item.user.lastname }}
              </div>
            </template>
            <span>{{ item.time }}</span>
          </v-tooltip>
        </template>
        <template v-slot:body.append>
          <tr :class="{ 'v-data-table__mobile-table-row': isMobile }">
            <td
              :colspan="`${isMobile ? 6 : Number(showHeaders.length) - 8 + 1}`"
              :class="{ 'v-data-table__mobile-row': isMobile }"
            >
              <strong>{{ $t("sum") }}</strong>
            </td>
            <td
              :colspan="`${isMobile ? 6 : 1}`"
              :class="{ 'v-data-table__mobile-row': isMobile }"
            >
              {{ isMobile ? $t("countProductInvoice") + ":" : "" }}
              {{ $numberFormat(totals.productCount) }}
            </td>
            <td
              :colspan="`${isMobile ? 6 : 1}`"
              :class="{ 'v-data-table__mobile-row': isMobile }"
            >
              {{ isMobile ? $t("countProductReturnInvoice") + ":" : "" }}
              {{ $numberFormat(totals.returnProductCount) }}
            </td>
            <td
              :colspan="`${isMobile ? 6 : 1}`"
              :class="{ 'v-data-table__mobile-row': isMobile }"
            >
              {{ isMobile ? $t("amountInvoice") + ":" : "" }}
              {{ $numberFormat(totals.sumInvoice) }}
            </td>
            <td
              :colspan="`${isMobile ? 6 : 1}`"
              :class="{ 'v-data-table__mobile-row': isMobile }"
            >
              {{ isMobile ? $t("amountReturnInvoice") + ":" : "" }}
              {{ $numberFormat(totals.sumReturnInvoice) }}
            </td>
            <td
              :colspan="`${isMobile ? 6 : 1}`"
              :class="{ 'v-data-table__mobile-row': isMobile }"
            >
              {{ isMobile ? $t("countInvoice") + ":" : "" }}
              {{ $numberFormat(totals.invoiceCount) }}
            </td>
            <td
              :colspan="`${isMobile ? 6 : 1}`"
              :class="{ 'v-data-table__mobile-row': isMobile }"
            >
              {{ isMobile ? $t("countReturnInvoice") + ":" : "" }}
              {{ $numberFormat(totals.returnInvoiceCount) }}
            </td>
            <td
              :colspan="`${isMobile ? 6 : 1}`"
              :class="{ 'v-data-table__mobile-row': isMobile }"
            >
              {{ isMobile ? $t("remainCount") + ":" : "" }}
              {{ $numberFormat(totals.remainCount) }}
            </td>
            <td
              :colspan="`${isMobile ? 6 : 1}`"
              :class="{ 'v-data-table__mobile-row': isMobile }"
            >
              {{ isMobile ? $t("remainAmount") + ":" : "" }}
              {{ $numberFormat(totals.remainAmount) }}
            </td>
          </tr>
        </template>
        <template v-slot:footer.prepend>
          <v-col v-show="!isMobile" cols="1" class="pa-0" style="margin-top: -10px">
            <v-text-field
              v-model.number="page"
              :label="$t('goToPage')"
              min="1"
              :max="pageCount"
              type="number"
              outlined
              height="32"
              hide-details
              hide-spin-buttons
              dense
              :suffix="'  /  ' + pageCount"
            />
          </v-col>
        </template>
      </v-data-table>
    </v-col>
    <v-row />
    <dialog-component
      :dialog-prop="innerComponent"
      :data-prop="dialogData"
      @close="innerComponent = false"
    />
    <v-dialog
      v-model="printDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="90%"
    >
      <v-card>
        <v-col class="d-flex pb-0">
          <v-btn icon color="grey darken-2" @click="printDialog = false">
            <v-icon class="close-hover" large> mdi-close </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t("print") }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <print
            :header-prop="showHeaders"
            :items-prop="items"
            :title="$t($route.name)"
          />
        </v-row>
        <v-card-actions />
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="invoicePrintDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="70%"
    >
      <v-card>
        <v-col class="d-flex pb-0">
          <v-btn icon color="grey darken-2" @click="invoicePrintDialog = false">
            <v-icon class="close-hover" large> mdi-close </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t("print") }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <invoicprint :id-prop="printId" />
        </v-row>
        <v-card-actions />
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="filter"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="70%"
      :draggable="true"
    >
      <v-card>
        <v-col class="d-flex">
          <v-btn icon color="grey darken-2" @click="filter = false">
            <v-icon class="close-hover" large> mdi-close </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t("filter") }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <v-col cols="12" md="4">
            <autocomplete
              v-model="account"
              :title="$t('customer')"
              type="person"
              :filter="true"
              :multiple="true"
            />
          </v-col>
          <v-col cols="12" md="4">
            <autocomplete
              v-model="product"
              type="product"
              :title="$t('product')"
              :outlined="true"
            />
          </v-col>
          <v-col cols="12" md="4">
            <status v-model="sellStatus" :hideconfig="true" />
          </v-col>
          <v-col cols="12" md="4">
            <autocomplete
              v-model="currencyFilter"
              :title="$t('currency')"
              type="currency"
              :filter="true"
              :multiple="true"
            />
          </v-col>
          <v-col cols="12" md="4">
            <v-text-field
              v-model="fromNumber"
              :label="$t('from') + ' ' + $t('number')"
              outlined
              dense
              clearable
            />
          </v-col>
          <v-col cols="12" md="4">
            <v-text-field
              v-model="toNumber"
              :label="$t('until') + ' ' + $t('number')"
              outlined
              dense
              clearable
            />
          </v-col>
          <v-col cols="12" md="4">
            <template>
              <v-text-field
                id="fromId"
                v-model="fromDate"
                :label="$t('from') + ' ' + $t('date')"
                outlined
                dense
                clearable
              />

              <date-picker
                v-model="fromDate"
                element="fromId"
                :locale="$store.state.date_locale"
                :format="$store.state.date_format"
                auto-submit
                :color="
                  this.$vuetify.theme.themes[
                    this.$vuetify.theme.isDark ? 'dark' : 'light'
                  ].primary
                "
                @close="setDate"
              />
            </template>
          </v-col>
          <v-col cols="12" md="4">
            <template>
              <v-text-field
                id="toId"
                v-model="toDate"
                :label="$t('until') + ' ' + $t('date')"
                outlined
                dense
                clearable
              />

              <date-picker
                v-model="toDate"
                element="toId"
                :locale="$store.state.date_locale"
                :format="$store.state.date_format"
                :min="fromDate"
                auto-submit
                :color="
                  this.$vuetify.theme.themes[
                    this.$vuetify.theme.isDark ? 'dark' : 'light'
                  ].primary
                "
                @close="setDate"
              />
            </template>
          </v-col>
          <v-col cols="12" md="4">
            <tag v-model="tag" />
          </v-col>
          <v-col cols="12" md="4">
            <v-select
              v-model="selectedHeaders"
              :items="headers"
              label="Select Columns"
              height="30"
              dense
              outlined
              multiple
              return-object
            >
              <template v-slot:selection="{ item, index }">
                <v-chip v-if="index < 2" small>
                  <span>{{ item.text }}</span>
                </v-chip>
                <v-chip v-if="index === 1" small>
                  <span>(+{{ selectedHeaders.length - 2 }} {{ $t("other") }})</span>
                </v-chip>
              </template>
            </v-select>
          </v-col>
          <v-col md="4">
            <autocomplete
              v-model="group"
              :title="$t('main-group')"
              type="productGroup"
              :data="JSON.stringify({ parent: null, type: 'group' })"
              :multiple="true"
              :filter="true"
            />
          </v-col>
          <v-col md="4">
            <autocomplete
              v-model="cat1"
              :title="$t('other-group')"
              type="productGroup"
              :data="JSON.stringify({ parent: null, type: 'category' })"
              :multiple="true"
              :filter="true"
            />
          </v-col>
          <v-col md="4">
            <autocomplete
              v-model="cat2"
              title="category"
              type="productGroup"
              :data="JSON.stringify({ parent: null, type: 'subcategory' })"
              :multiple="true"
              :filter="true"
            />
          </v-col>
          <v-col cols="12" md="4">
            <autocomplete
              v-model="branch"
              title="branch"
              type="branch"
              :filter="true"
              :multiple="true"
            />
          </v-col>
          <v-col cols="12" md="4">
            <autocomplete
              v-model="entrepot"
              title="entrepot"
              type="entrepot"
              :filter="true"
              :multiple="true"
            />
          </v-col>
          <v-col cols="12" md="4">
            <autocomplete
              v-model="seller"
              title="visitor"
              type="person"
              :data="JSON.stringify({ type: 'visitor' })"
              :multiple="true"
              :filter="true"
            />
          </v-col>
          <!--add account Category -->
          <v-col cols="12" md="4">
            <autocomplete
              v-model="accountCategory"
              :title="$t('accountCategory')"
              type="accountCategory"
              :multiple="true"
              :filter="true"
            />
          </v-col>
        </v-row>
        <v-card-actions class="px-3">
          <v-row class="ma-0">
            <v-col cols="6" class="pa-0 py-1">
              <v-btn class="mx-0" color="primary" @click="getItems">
                {{ $t("filter") }}
              </v-btn>
            </v-col>
            <v-col cols="6" class="pa-0 py-1">
              <v-btn
                color="grey"
                outlined
                class="float-left mx-0"
                @click="filter = false"
              >
                {{ $t("cancel") }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="taskDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="90%"
    >
      <v-card>
        <v-col class="d-flex">
          <v-btn icon color="grey darken-2" @click="taskDialog = false">
            <v-icon class="close-hover" large> mdi-close </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t("task") }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <task
            task-type="account"
            :ref-id="refId"
            :task-id="taskId"
            @close="taskDialog = false"
          />
        </v-row>
        <v-card-actions />
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="deletDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="400"
    >
      <v-card>
        <v-col>
          <v-btn icon class="close-hover" @click="deletDialog = false">
            <v-icon color="grey" large> mdi-close </v-icon>
          </v-btn>
        </v-col>
        <v-col>
          <v-img class="mx-auto" width="200" src="@/assets/stop.svg" />
        </v-col>
        <v-col class="mt-3 pr-7">
          <p class="mx-auto font-weight-medium">
            {{ $t("are-you-sure-delete-this-case") }}
          </p>
        </v-col>
        <v-card-actions>
          <v-row class="ma-0">
            <v-col cols="6">
              <v-btn v-if="selected.length > 0" color="primary" @click="removegroup">
                {{ $t("remove") }}
              </v-btn>
              <v-btn v-if="selected.length == 0" color="primary" @click="remove">
                {{ $t("remove") }}
              </v-btn>
            </v-col>
            <v-col cols="6">
              <v-btn
                color="grey"
                outlined
                class="float-left"
                @click="deletDialog = false"
              >
                {{ $t("cancel") }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <snakbar
      v-model="snakbar"
      :text="snakbarText"
      :active="snakbar"
      :color="snakbarColor"
    />
  </v-card>
</template>

<script>
import Task from "../task/task";
import Print from "../../components/general/Print/Index";
import Invoicprint from "./print";
import General from "../../../../Mixins/general";
export default {
  name: "TypeItemsList",
  components: {
    autocomplete: () => import("../../components/general/patial/autocomplete"),
    Snakbar: () => import("../../components/general/snakbar/snakbar"),
    Tag: () => import("../../components/general/Tag/tag"),
    Status: () => import("../../components/general/Status/status"),
    dialogComponent: () => import("../../components/general/dialog/index"),
    Invoicprint,
    Print,
    Task,
  },
  mixins: [General],
  props: ["input", "refId", "mobileShow"],
  data: () => ({
    excelItems: [],
    selected: [],
    accountCategory: null,
    invoicePrintDialog: false,
    printDialog: false,
    deletDialog: false,
    seller: null,
    cat2: null,
    cat1: null,
    group: null,
    entrepot: null,
    product: null,
    dialogData: null,
    account: null,
    currencyFilter: null,
    fromAmount: null,
    toAmount: null,
    fromNumber: null,
    toNumber: null,
    fromDate: null,
    toDate: null,
    printId: null,
    filter: false,
    productStatus: null,
    productStatusItems: null,
    model: null,
    from: 1,
    pageCount: 1,
    page: 1,
    taskDialog: null,
    tag: null,
    temp: null,
    deleteItem: null,
    sellStatus: null,
    items: [],
    sortBy: [],
    dialog: null,
    timer: 0,
    totalItems: 0,
    snakbar: false,
    typeForm: null,
    taskId: null,
    snakbarText: null,
    loading: true,
    options: {
      itemsPerPage: 5,
    },
    headers: null,
    type: null,
    search: null,
    selectedHeaders: [],
    headersMap: null,
  }),
  computed: {
    showSelect() {
      if (!this.isMobile) {
        return true;
      } else {
        return false;
      }
    },
    isMobile() {
      return this.$vuetify.breakpoint.name === "xs";
    },
    showHeaders() {
      var app = this;
      return this.headers.filter(function (s) {
        if (app.type === "purchase" || app.type === "returnSell") {
          if (s.value === "cost" || s.value === "profit") {
          } else {
            return app.selectedHeaders.includes(s);
          }
        } else {
          return app.selectedHeaders.includes(s);
        }
      });
    },
    totals: function () {
      const totals = this.items.reduce(
        (acc, d) => {
          acc.productCount += parseFloat(d.count_product_invoice);
          acc.returnProductCount += parseFloat(d.count_product_return_invoice);
          acc.sumInvoice += parseFloat(d.amount_invoice);
          acc.sumReturnInvoice += parseFloat(d.amount_return_invoice);
          acc.invoiceCount += parseFloat(d.count_invoice);
          acc.returnInvoiceCount += parseFloat(d.count_return_invoice);
          acc.remainAmount += parseFloat(+d.amount_invoice - +d.amount_return_invoice);
          acc.remainCount += parseFloat(
            +d.count_product_invoice - +d.count_product_return_invoice
          );
          return acc;
        },
        {
          productCount: 0,
          returnProductCount: 0,
          sumInvoice: 0,
          sumReturnInvoice: 0,
          invoiceCount: 0,
          returnInvoiceCount: 0,
          remainAmount: 0,
          remainCount: 0,
        }
      );
      return totals;
    },
  },
  watch: {
    refId(val, oldVal) {
      // this.items = []
      this.getItems();
    },
    model() {
      this.$emit("input", this.model);
    },
    selected() {
      this.$emit("input", this.selected.text);
      if (this.selected.length > 0) {
        this.model = this.selected[0].text;
        this.temp = this.selected[0].text;
      }
      this.dialog = false;
    },
    search() {
      var app = this;
      app.loading = true;
      app.page = 1;
      clearTimeout(this.timer);
      this.timer = setTimeout(function () {
        app.getItems();
      }, 1000);
    },
    options: {
      handler() {
        var app = this;
        app.sortBy = [];
        app.options.sortBy.map(function (value, key) {
          const index = app.headers.findIndex((h) => h.value === value);
          app.sortBy.push(app.headers[index].table);
        });
        this.getItems();
      },
      deep: true,
    },
    sortBy() {
      const index = this.headers.findIndex((h) => h.value === this.sortBy);
      if (index > -1) {
        this.sortBy = this.headers[index].table;
      }
    },
  },
  activated() {
    // this.getItems()
  },
  beforeMount() {
    if (this.$route.name === "sellProductReport") {
      this.type = "sell";
    }
    if (this.$route.name === "purchaseProductReport") {
      this.type = "purchase";
    }
    this.headers = [
      {
        text: this.$t("actions"),
        align: "start",
        sortable: false,
        value: "actions",
        width: 20,
      },
      {
        text: this.$t("row"),
        align: "start",
        sortable: false,
        value: "row",
        width: 20,
      },
      {
        text: this.$t("product"),
        sortable: false,
        value: "product.name",
      },
      {
        text: this.$t("unit"),
        sortable: false,
        value: "product.unit.fame",
      },
      {
        text: this.$t("countProductInvoice"),
        sortable: false,
        value: "count_product_invoice",
      },
      {
        text: this.$t("countProductReturnInvoice"),
        sortable: false,
        value: "count_product_return_invoice",
      },
      {
        text: this.$t("amountInvoice") + "(" + this.$store.state.currency.symbol + ")",
        sortable: false,
        value: "amount_invoice",
      },
      {
        text:
          this.$t("amountReturnInvoice") + "(" + this.$store.state.currency.symbol + ")",
        sortable: false,
        value: "amount_return_invoice",
      },
      {
        text: this.$t("countInvoice"),
        sortable: false,
        value: "count_invoice",
      },
      {
        text: this.$t("countReturnInvoice"),
        sortable: false,
        value: "count_return_invoice",
      },
      {
        text: this.$t("remainCount"),
        sortable: false,
        value: "remainCount",
      },
      {
        text: this.$t("remainAmount") + "(" + this.$store.state.currency.symbol + ")",
        sortable: false,
        value: "remainAmount",
      },
    ];
    this.productStatusItems = [
      {
        value: "active",
        text: this.$t("active"),
      },
      {
        value: "deactive",
        text: this.$t("deactive"),
      },
    ];
    if (this.input) {
      this.model = this.input;
    }
    this.headersMap = this.headers;
    this.selectedHeaders = this.headers;
  },
  mounted() {},
  methods: {
    openComponent(component, id) {
      this.dialogData = {
        name: component,
        id: id,
      };
      this.innerComponent = true;
    },
    openDeleteDialog(item) {
      this.deleteItem = item;
      this.deletDialog = true;
    },
    openTaskDialog(item) {
      this.refId = item.rel_id;
      this.taskId = item.id;
      this.taskDialog = true;
    },
    isEnabled(slot) {
      return this.enabled === slot;
    },
    edit(item) {
      this.$router.push({ name: this.type + "Edit", params: { id: item.head.uid } });
    },
    print(item) {
      this.printId = item.head.uid;
      this.invoicePrintDialog = true;
    },
    getItems() {
      var app = this;
      app.loading = true;
      app.filter = false;
      app.$axios
        .get(this.$endpoint + "invoiceReport", {
          params: {
            select: "typeProductItems",
            seller: app.seller,
            group: app.group,
            cat1: app.cat1,
            cat2: app.cat2,
            branch: app.branch,
            entrepot: app.entrepot,
            product: app.product,
            search: app.search,
            account: app.account,
            accountCategory: app.accountCategory,
            fromDate: app.fromDate,
            toDate: app.toDate,
            fromAmount: app.fromAmount,
            toAmount: app.toAmount,
            fromNumber: app.fromNumber,
            toNumber: app.toNumber,
            currency: app.currencyFilter,
            page: app.allRows ? app.excelPage : app.options.page,
            refId: app.refId,
            type: app.type,
            sortBy: app.sortBy,
            status: app.productStatus,
            options: app.options,
            tag: app.tag,
            typeForm: app.typeForm,
          },
        })
        .then((res) => {
          res = res.data;
          if (!app.allRows) {
            app.items = res.data;
            app.totalItems = res.total;
            app.pageCount = res.last_page;
            app.from = res.from;
            app.creatExcelData(res.data);
          } else {
            app.generateExcellForAllData(res.data, res.last_page);
          }
        })
        .catch((err) => {
          this.serverErrorHandeler(err);
        })
        .finally(() => (app.loading = false));
    },
    remove() {
      var app = this;
      if (!app.deleteItem) return false;
      app.loading = true;
      app.$axios
        .delete(this.$endpoint + "invoice/" + this.deleteItem.id)
        .then((res) => {
          res = res.data;
          app.deletDialog = false;
          app.deleteItem = null;
          app.getItems();
        })
        .catch((err) => {
          this.deletDialog = false;
          this.serverErrorHandeler(err);
        })
        .finally(() => (app.loading = false));
    },
    removegroup() {
      var app = this;
      app.loading = true;
      app.$axios
        .get(this.$endpoint + "invoice", {
          params: {
            deleteItems: app.selected,
          },
        })
        .then((res) => {
          res = res.data;
          app.deletDialog = false;
          app.deleteItem = null;
          app.selected = [];
          app.getItems();
        })
        .catch((err) => {
          this.deletDialog = false;
          this.serverErrorHandeler(err);
        })
        .finally(() => (app.loading = false));
    },
    creatExcelData(data, type = "page") {
      var app = this;
      if (type === "page") {
        app.excelItems = [];
      }
      data.map(function (d) {
        app.excelItems.push({
          type: app.$t(app.type),
          product: d.product ? d.product.name : "",
          barcode: d.product && d.product.barcode ? d.product.barcode : "",
          unit: d.product && d.product.unit ? d.product.unit.fame : "",
          productCount: d.count_product_invoice,
          returnProductCount: d.count_product_return_invoice,
          invoiceCount: d.count_invoice,
          returnInvoiceCount: d.count_return_invoice,
          sumInvoice: app.$numberFormat(d.amount_invoice),
          sumReturnInvoice: app.$numberFormat(d.amount_return_invoice),
          remainAmount: +d.amount_invoice - +d.amount_return_invoice,
          remainCount: +d.count_product_invoice - +d.count_product_return_invoice,
          total_discount: d.discount ? d.discount : "",
        });
      });
    },
  },
};
</script>

<style scoped>
::v-deep .v-data-table table thead tr th,
::v-deep .v-data-table table tbody tr td {
  white-space: nowrap;
}
::v-deep
  .v-text-field--outlined.v-input--dense.v-text-field--outlined
  > .v-input__control
  > .v-input__slot {
  min-height: 32px !important;
}
</style>
